import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_REGION, buildRegionPath, useActiveRegion } from '../regions';
import { emailAddresses } from '../config/emails';

const Footer: React.FC = () => {
  const activeRegion = useActiveRegion() ?? DEFAULT_REGION;
  const regionPath = (path?: string) => buildRegionPath(activeRegion, path);
  const { hello, support } = emailAddresses;

  return (
    <footer className="bg-slate-900 text-slate-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <h3 className="text-sm font-semibold tracking-wide text-slate-300">OppFoundry</h3>
            <p className="mt-4 text-sm text-slate-200">
              Find relevant municipal and commercial contract opportunities across Massachusetts. Perfect for service
              businesses looking to grow.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-300">Navigation</h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-200">
              <li>
                <Link to="/" className="hover:text-white">Home</Link>
              </li>
              <li>
                <Link to={regionPath('opportunities')} className="hover:text-white">Browse Opportunities</Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white">Blog</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">Contact</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white">About</Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-300">Contact</h3>
            <p className="mt-4 text-sm text-slate-200">
              Get in touch{' '}
              <a href={`mailto:${hello}`} className="font-medium hover:text-white">
                {hello}
              </a>
            </p>
            <p className="mt-2 text-sm text-slate-200">
              Need support?{' '}
              <a href={`mailto:${support}`} className="font-medium hover:text-white">
                {support}
              </a>
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-300">Legal</h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-200">
              <li>
                <Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-slate-700 pt-6 text-center text-xs text-slate-400">
          © {new Date().getFullYear()} OppFoundry. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
